import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";

type sanitizerType = 'html' | 'style' | 'script' | 'url' | 'resource'

@Pipe({
  name: 'customSanitizer',
  standalone: true
})
export class SanitizerPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: any, type: sanitizerType = 'html'): any {
    switch (type) {
      case 'style':
        return this.sanitizer.bypassSecurityTrustStyle(value)
      case 'script':
        return this.sanitizer.bypassSecurityTrustScript(value)
      case 'url':
        return this.sanitizer.bypassSecurityTrustUrl(value)
      case 'resource':
        return this.sanitizer.bypassSecurityTrustResourceUrl(value)
      case 'html':
      default:
        return this.sanitizer.bypassSecurityTrustHtml(value)
    }

  }
}
